import { render, staticRenderFns } from "./full-screen.vue?vue&type=template&id=4d1f0c98&scoped=true"
import script from "./full-screen.vue?vue&type=script&lang=js"
export * from "./full-screen.vue?vue&type=script&lang=js"
import style0 from "./full-screen.vue?vue&type=style&index=0&id=4d1f0c98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1f0c98",
  null
  
)

export default component.exports